module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/black-526d6f02f5e4ded8978bd5a9f6b29de0.png";